<template>
  <div class="mobParentalCon">
    <div class="costContainer" v-loading="loading">
      <!-- <div class="headerCon">
        <div class="left"><van-icon name="arrow-left" @click="$router.push('/mobile/home');" /></div>
        <div class="headerTit">育儿假查询</div>
        <div class="right">
        </div>
      </div> -->

      <div class="selectCon">
        <el-date-picker v-model="infoFrom.year" type="year" placeholder="请选择年份" clearable @change="changeYear"
          size="small">
        </el-date-picker>
      </div>


      <div class="main">
        <div class="main_text">
          <img class="main_img" src="../../assets/mobParental/icon4.png" alt="">
          <div class="titleR">
            <div class="title_text">总计年度育儿假</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List1 == '--' ? '--' : dataList.List1 + '小时'
              }}</div>
          </div>
        </div>
        <div class="main_text">
          <img class="main_img" src="../../assets/mobParental/icon3.png" alt="">
          <div class="titleR">
            <div class="title_text">已使用育儿假</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List2 == '--' ? '--' : dataList.List2 + '小时'
              }}</div>
          </div>
        </div>
        <div class="main_text">
          <img class="main_img" src="../../assets/mobParental/icon2.png" alt="">
          <div class="titleR">
            <div class="title_text">育儿假结余</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ dataList.List3 == '--' ? '--' : dataList.List3 + '小时'
              }}</div>
          </div>
        </div>
        <div class="main_text">
          <img class="main_img" src="../../assets/mobParental/icon1.png" alt="">
          <div class="titleR">
            <div class="title_text">使用时间</div>
            <div class="bottom_text" style="margin-top: 4px;">{{ tableData[0]?.ksxyrq1 }} - {{
      tableData[0]?.effexpirationdateDate1 }}</div>
          </div>
        </div>
        <div class="footerBtn">
          <span class="hint">*</span>基于您在考勤系统中的记录显示，截止到目前为止,
          <span>{{ tableData[0]?.year ? tableData[0]?.year : '--' }}年还有育儿假{{ dataList.List3 == '--' ? '--小时' :
      dataList.List3
      + '小时'
            }}，请于{{ tableData[0]?.effexpirationdateDate1 ? tableData[0]?.effexpirationdateDate1 : '--' }}前使用,</span>
          逾期仍未使用的部分视为自动放弃。
        </div>
      </div>




    </div>
  </div>
  <!-- <div class="costContent">
        <el-table :data="tableData" style="width: 100%" border :header-cell-style="{ background: '#F7F9FA' }"
          :max-height="windowHeight" v-loading="loading">
          <el-table-column prop="year" label="年度" align="center" min-width="80">
          </el-table-column>
          <el-table-column prop="total" label="育儿假总计" align="center" min-width="90">
          </el-table-column>
          <el-table-column prop="zkc" align="center" label="使用" width="80">
          </el-table-column>
          <el-table-column prop="balance" align="center" label="结余" width="70">
          </el-table-column>
          <el-table-column prop="ksxyrq" align="left" label="开始时间" width="80" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="effexpirationdate" align="left" label="截止时间" width="80" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <div class="pageContainer">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="pageData.page" :page-sizes="[10, 20, 50, 80, 100]" :page-size="pageData.pageSize"
            layout="total, prev, pager, next,sizes" :total="total">
          </el-pagination>
        </div>
      
      </div> -->
</template>

<script>
// import apis from "@/apis/insurance.js";
import api from "@/apis";
import moment from "moment";
import apiLogin from "@/apis";
import "moment/locale/zh-cn";
import { getToken } from "@/utils/cookie";
export default {
  name: "mobParental",
  data() {
    return {
      options: [],
      tableData: [],
      childrenNameList: [],
      pageData: {
        page: 1,
        pageSize: 20
      },
      total: 0,
      fileListTwo: [],
      windowHeight: '700',
      loading: false,
      infoFrom: {
        empno: "",
        name: '',
        year: moment().format('YYYY'),
      },
    };
  },

  computed: {
    dataList() {
      const List1 = this.nullTransformation(this.tableData[0]?.total)
      const List2 = this.nullTransformation(this.tableData[0]?.zkc)
      const List3 = this.nullTransformation(this.tableData[0]?.balance)
      return {
        List1,
        List2,
        List3,
      };
    },
  },

  mounted() {
    window.addEventListener('resize', this.handleResize);
    this.handleResize();
    let token = getToken();
    if (token) {
      this.getList();
    } else {
      this.$bus.$on("processToken", (res) => {
        Promise.resolve(this.getHrToken(res)).then(() => {
          this.getList();
        });
      });
    }
  },

  //销毁时移除事件监听器
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {

    // 处理窗口大小变化
    handleResize() {
      this.windowHeight = window.innerHeight - 295;
    },

  // 处理空值和百分比的转换
    nullTransformation(data, type = "--") {
      if (
        data === null ||
        data === undefined ||
        data === "null%" ||
        data === "undefined%"
      ) {
        return "--";
      }
      // return data ? data : type;
      if (
        typeof data === "string" &&
        data.endsWith("%") &&
        parseFloat(data) === 0
      ) {
        return type;
      }
      // 如果输入是百分比字符串，则直接返回
      else if (typeof data === "string" && data.endsWith("%")) {
        return data;
      }
      // 如果输入是数字0，则返回type
      else if (data == 0) {
        return type;
      }
      // 其他情况，直接返回原始输入
      else {
        return data;
      }
    },

  // 获取hrToken&用户信息
    getHrToken(username) {
      return new Promise((resolve) => {
        if (username) {
          let thisname = username;
          if (thisname === "17625010228" || thisname === "17637403245") {
            thisname = "10005038";
          } else if (thisname === "15093054787") {
            thisname = "10005038";
          }

          apiLogin.getUserToken({ username: thisname }).then((data) => {
            const info = data.data;
            window.sessionStorage.hrToken = info.auth_token;
            resolve();
          });
        } else {
          // console.log("未登录");
          resolve();
        }
      });
    },
    // 获取育儿假列表
    getList() {
      this.infoFrom.empno = getToken();
      this.loading = true;
      this.pageData = {
        page: 1,
        pageSize: 20
      };
      api
        .parentingList({ ...this.infoFrom, ...this.pageData })
        .then((data) => {
          // const res = data.data.hrLeaveBalanceList
          // this.tableData = []
          // res.forEach(item=>{
          //   if(item.holidayNum != 0){
          //     this.tableData.push(item)
          //   }
          // })
          this.tableData = data.data.map(item => {
            item.ksxyrqDate = item.ksxyrq ? moment(item.ksxyrq).format('YYYY年MM月DD日') : "";
            item.effexpirationdateDate = item.effexpirationdate ? moment(item.effexpirationdate).format('YYYY年MM月DD日') : "";
            item.ksxyrq1 = item.ksxyrq ? moment(item.ksxyrq).format('YYYY/MM/DD') : "";

            item.effexpirationdateDate1 = item.effexpirationdate ? moment(item.effexpirationdate).format('YYYY/MM/DD') : "";
            return item;
          });
          console.log(data, "data");
          this.total = data.total;
          this.code = data.code;
        })
        .finally(() => (this.loading = false));
    },
    // 获取育儿假列表
    getList1() {
      this.infoFrom.empno = getToken();
      this.loading = true;
      api
        .parentingList({ ...this.infoFrom, ...this.pageData })
        .then((data) => {
          const res = data.data
          this.tableData = []
          res.forEach(item => {
            if (item.balance != 0) {
              item.ksxyrqDate = item.ksxyrq ? moment(item.ksxyrq).format('YYYY年MM月DD日') : "";
              item.effexpirationdateDate = item.effexpirationdate ? moment(item.effexpirationdate).format('YYYY年MM月DD日') : "";
              item.effexpirationdateDate1 = item.effexpirationdate ? moment(item.effexpirationdate).format('YYYY/MM/DD') : "";
              item.ksxyrq1 = item.ksxyrq ? moment(item.ksxyrq).format('YYYY/MM/DD') : "";
              this.tableData.push(item)
            }
          })
          // this.tableData = data.data.map(item => {
          //   item.ksxyrqDate = item.ksxyrq ? moment(item.ksxyrq).format('YYYY年MM月DD日') : "";
          //   item.effexpirationdateDate = item.effexpirationdate ? moment(item.effexpirationdate).format('YYYY年MM月DD日') : "";
          //   return item;
          // });
          console.log(data, "data");
          this.total = data.total;
          this.code = data.code;
        })
        .finally(() => (this.loading = false));
    },
    // 切换日期
    changeYear(value) {
      this.infoFrom.year = value ? moment(value).format("YYYY") : '';
      this.getList();
    },
    // 每页条数
    handleSizeChange(val) {
      this.pageData.pageSize = val;
      this.getList1();
    },
    // 当前页
    handleCurrentChange(val) {
      this.pageData.page = val;
      this.getList1();
    },
  }
};
</script>
<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .costContainer {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .costContainer {
    width: 276px * $zoom;
  }
}

.footerBtn {
  width: 100%;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  color: #7c7c7c;
  margin-top: 20px;

  .hint {
    color: red;
  }
}

.main {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: 0 30px;
}

.main_text {
  width: 100%;
  height: 50px* $zoom;
  display: flex;
  background: #FFFFFF;
  box-shadow: 0px 2px 5px 0px rgba(27, 122, 30, 0.13);
  border-radius: 10px;
  align-items: center;
  margin-top: 40px;


  .main_img {
    width: 30px* $zoom;
    height: 30px* $zoom;
    margin-left: 20px;
  }

  .titleR {
    margin-left: 16PX;

    .title_text {
      font-size: 9px* $zoom;
      color: #999999;
    }

    .bottom_text {
      font-weight: 600;
      font-size: 12px* $zoom;
      color: #22AB6D;
    }

  }

}




.mobParentalCon {

  width: 100%;
  display: flex;
  justify-content: center;
  height: 100vh;
}

::v-deep {
  .el-table .cell.el-tooltip {
    width: 100% !important;
  }
}

.costContainer {
  background-image: url('../../assets/mobParental/mobParental-Bg.png');
  background-repeat: no-repeat;
  background-size: 100% 100vh;
  padding-top: 20px;
  // background-color: #fff;

  .headerCon {
    display: flex;
    align-content: center;
    justify-content: space-between;
    border-bottom: 1px solid #ececec;
    padding: 0 20px 15px 20px;

    .left {
      .van-icon {
        font-size: 36px;
      }
    }

    .headerTit {
      font-family: PingFang-SC, PingFang-SC;
      font-weight: 600;
      font-size: 37px;
      color: #282B32;
    }

    .right {
      img {
        width: 36px;
        height: 36px;
      }
    }
  }

  .selectCon {
    // // height: 112px;
    // // background-color: #fff;
    padding: 0 30px;

    // padding: 20px;
    // display: flex;

    // // justify-content: flex-end;
    ::v-deep {
      .el-date-editor {

        .el-input__inner {
          height: 25px *$zoom;
        }

        width: 100%;
        // height: 38px;
      }
    }



  }

  .costContent {
    // height: calc(100vh - 420px);
    // height: 100%;
    overflow-y: auto;
    padding-bottom: 20px;
    // background-color: #fff;
  }



  .pageContainer {
    display: flex;
    justify-content: flex-end;
    margin-top: 30px;
  }
}
</style>
